//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type CollectionId = Opaque<string, 'CollectionId'>;

function CollectionIdFactory(collectionId: string) {
  return collectionId as CollectionId;
}

const CollectionId = CollectionIdFactory;

export default CollectionId;
